import {ACTION_TYPE} from "utils";

export const changeAdUsedState = (size, bool) => ({
  type: ACTION_TYPE.CHANGE_AD_USED_STATE,
  size,
  bool,
});

export const changeAdShowState = (size, bool) => ({
  type: ACTION_TYPE.CHANGE_AD_SHOW_STATE,
  size,
  bool,
});

export const changeAdPosition = (size, x, y) => ({
  type: ACTION_TYPE.CHANGE_AD_POSITION,
  size,
  x,
  y,
});
